/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskModel } from './TaskModel';
import {
    TaskModelFromJSON,
    TaskModelFromJSONTyped,
    TaskModelToJSON,
    TaskModelToJSONTyped,
} from './TaskModel';

/**
 * 
 * @export
 * @interface GetTasksResponse
 */
export interface GetTasksResponse {
    /**
     * 
     * @type {Array<TaskModel>}
     * @memberof GetTasksResponse
     */
    items?: Array<TaskModel>;
    /**
     * 
     * @type {number}
     * @memberof GetTasksResponse
     */
    numberOfItems?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTasksResponse
     */
    numberOfPages?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTasksResponse
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the GetTasksResponse interface.
 */
export function instanceOfGetTasksResponse(value: object): value is GetTasksResponse {
    return true;
}

export function GetTasksResponseFromJSON(json: any): GetTasksResponse {
    return GetTasksResponseFromJSONTyped(json, false);
}

export function GetTasksResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTasksResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(TaskModelFromJSON)),
        'numberOfItems': json['numberOfItems'] == null ? undefined : json['numberOfItems'],
        'numberOfPages': json['numberOfPages'] == null ? undefined : json['numberOfPages'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function GetTasksResponseToJSON(json: any): GetTasksResponse {
    return GetTasksResponseToJSONTyped(json, false);
}

export function GetTasksResponseToJSONTyped(value?: GetTasksResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(TaskModelToJSON)),
        'numberOfItems': value['numberOfItems'],
        'numberOfPages': value['numberOfPages'],
        'pageSize': value['pageSize'],
    };
}

